import { type HydrateWidgetFn } from '@framework/engine/hydrate/IHydrationContext.ts';
import { get } from 'lodash';
import { uploadWidgetFilenameField } from './createUploadWidgetFormSchema.ts';
import { type IUploadWidget } from './IUploadWidget.ts';

export const hydrateUploadWidget: HydrateWidgetFn<IUploadWidget> = ({
  context,
  path,
}) => {
  const value = get(context.values, path);
  const filename = get(context.values, uploadWidgetFilenameField(path));

  return {
    value: value ?? undefined,
    filename: filename ?? undefined,
  };
};
